<template>
    <div v-if="loading">
        <!-- MDL Progress Bar with Indeterminate Progress -->
        <div class="mdl-spinner mdl-js-spinner is-active"></div>
    </div>
    <div v-if="errored">
      An error occurred while loading your magnet. Please scan the QR code again.
    </div>

    <div v-if="!loading && !errored" class="magnet">
      
      <img id="magnet-motif" v-bind:src="imageSrc" alt="magnet-motif">
      <p id="sight">{{ sight.name }}</p>
      <p id="place">{{ sight.town }}, {{ sight.country }}</p>
      <div v-if="updatable">
        <form id="updateForm">
          <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
            <label for="post_updatable">Add your personal text:</label>
            <textarea v-model="magnet.post" class="mdl-textfield__input" type="text" rows= "5" id="post_updatable"></textarea>
          </div>
          <button id="submitUpdate" v-on:click="updateMagnetAndCheckbox" class="mdl-button mdl-js-button mdl-button--raised">
            Update personal Text
          </button>
        </form>
      </div>
      <div v-else>
        <p id="post_written">{{ magnet.post }}</p>
      </div>
      <label id="togglestreetview" class="mdl-switch mdl-js-switch mdl-js-ripple-effect" for="switch-1">
        <input type="checkbox" id="switch-1" class="mdl-switch__input" v-model="updatable">
        <span class="mdl-switch__label">Change personal text</span>
      </label>


      <Maps :coordinateX="sight.coordinateX" :coordinateY="sight.coordinateY" />

    </div>
</template>

<script>
import Maps from './Maps.vue';

export default {
  name: 'ExistingMagnet',
  components: {
    Maps,
  },
  props: {
    magnetIdentification: {
      type: String,
      default: '',
    },
  },
  data () {
      return {
          url: null,
          magnet: null,
          sight: null,
          imageSrc: null,
          iframeSrc: null,
          loading: true,
          errored: false,
          empty: true,
          updatable: false,
          updateableChanged: false,
          svIsOn: false,
          json: null,
      }
  },
  methods: {
    updateMagnet: function() {
      this.magnet.last_updated = new Date()
      this.json = JSON.stringify(this.magnet);
      fetch('https://strapi.levt.online/magnets/' + this.magnet.id, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: this.json,
      })
      .then(response => response.json())
      .catch((error) => {
        console.error('Error:', error);
      })
      .finally(data => {
        console.log('Success :', data);
      });
      console.log(this.json);
    },
    updateMagnetAndCheckbox: function() {
      this.updateMagnet()
      this.updatable = false;
    }
  },
  mounted: function () {
      this.url = "https://strapi.levt.online/magnets?magnetID_eq=" + this.magnetIdentification;
      fetch(this.url)
      .then(response => response.json())
      .then(response => {
          this.magnet = response[0]
      })
      .catch(error => {
          console.error(error)
          this.errored = true
      })
      .finally(() => {
        this.imageSrc = "https://strapi.levt.online" + this.magnet.magnettype.image.url
        this.empty = this.magnet.post == null
        fetch("https://strapi.levt.online/sights/"+ this.magnet.magnettype.sight)
        .then(response => response.json())
        .then(response => {
          this.sight = response
        })
        .catch(error => {
          console.error(error)
          this.errored = true
        })
        .finally(() => {
          
          this.loading = false
        });
      });

      
  },
  updated: function () {
    if(this.updateableChanged != this.updatable){
      if(this.updatable == false){
        this.updateMagnet()
      }
      this.updateableChanged = this.updatable
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

#sight {
  font-size: 170%;
  margin: 0%;
}

.magnet {
  display: flex;
  flex-flow:column;
}

#magnet-motif {
  width: 90%;
  height: auto;
  margin: 5%;
}

#post_written {
  margin: 5%;
}

#updatetext {
  margin: 0 10% 0 10%;
}

#updateForm {
  display: flex;
  flex-flow: column;
  size: 90%;
  margin: 5%;
}
</style>